<template>
  <v-container v-if="showLogin" id="login" class="fill-height" tag="section">
    <v-row class="mx-auto" justify="center" align="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Login</h1>

              <!-- <v-btn
                v-for="(social, i) in socials"
                :key="i"
                :href="social.href"
                class="ma-1"
                icon
                rel="noopener"
                target="_blank"
              >
                <v-icon v-text="social.icon" />
              </v-btn> -->
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-light">
              Entra con tu email
            </div>

            <v-text-field
              v-model="email"
              :error-messages="emailErrors"
              color="secondary"
              label="Email..."
              prepend-icon="mdi-email"
              class="mt-6"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              @keyup.enter="submit"
            />

            <v-text-field
              class="mb-8"
              color="secondary"
              v-model="password"
              prepend-icon="mdi-lock-outline"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              :error-messages="passErrors"
              label="Contraseña"
              required
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @keyup.enter="submit"
            />

            <pages-btn
              large
              color
              depressed
              class="v-btn--text success--text"
              @click="submit"
              :loading="loadingForm"
              >Vamos</pages-btn
            >
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
  <v-container v-else-if="showNoAdmin" align-center justify-center fill-height>
    <v-row>
      <v-spacer />
      <v-col cols="6">
        <v-alert type="warning" color="warning">
          Estás logueado pero no eres usuario con permiso de administración.
          Deslogueate o ve a la página de tu rol
          <v-btn text @click="logout" :loading="loadingLogout">SALIR</v-btn>
        </v-alert>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { mapActions, mapState, mapGetters } from "vuex";
import { goPanel } from "@/utils/router.js";
export default {
  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required },
  },
  data: function () {
    return {
      loadingLogout: false,
      email: "",
      password: "",
      loadingForm: false,
      errorLogin: false,
      show1: false,
      socials: [
        {
          href: "#",
          icon: "mdi-facebook-box",
        },
        {
          href: "#",
          icon: "mdi-twitter",
        },
        {
          href: "#",
          icon: "mdi-github-box",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      role: "auth/role",
    }),
    ...mapState({
      isLogged: (state) => state.auth.isLogged,
      rolesAdmin: (state) => state.users.rolesAdmin,
    }),
    noAdmin() {
      return !this.rolesAdmin.includes(this.role);
    },
    showLogin() {
      return !this.isLogged;
    },
    showNoAdmin() {
      return this.isLogged && this.noAdmin;
    },
    passErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Contraseña requerida.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("E-mail no válido");
      !this.$v.email.required && errors.push("E-mail requerido");
      return errors;
    },
  },
  methods: {
    logout() {
      let _vm = this;
      this.loadingLogout = true;
      this.$store
        .dispatch("auth/firebaseLogout")
        .then(() => {
          this.$router.push("/login");
        })
        .finally(() => (_vm.loadingLogout = false));
    },
    firebaseLogin(email, pass) {
      let obj = {
        email: email,
        password: pass,
      };
      this.loadingForm = true;
      this.$store
        .dispatch("auth/firebaseLogin", obj)
        .then((r) => {
          console.log(goPanel());
          this.$router.push(goPanel());
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Usuario / contraseña incorrecto",
          });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        this.firebaseLogin(this.email, this.password);
      }
    },
    clear() {
      this.$v.$reset();
      this.password = "";
      this.email = "";
      //this.select = null
      //this.checkbox = false
    },
  },
  mounted() {},
};
</script>
<style scoped>
.borderB {
  border: 1px solid #fff;
}
</style>
